export default "__VITE_ASSET__be425196__"